<template>
  <div class="wrapper fill-vh">
    <div>
      <div class="heading">
        <h2>Kiitos passin lataamisesta!</h2>
      </div>
      <p class="air">
        Passin pitäisi saapua antamaasi sähköpostiosoitteeseen
        <small>({{ userData.fields.all.email }})</small> muutaman minuutin
        kuluessa.
      </p>
      <MobileForm v-if="!userData.fields.all.mobile" />
      <InfoCollapsible />
    </div>

    <div>
      <div class="buttons">
        <Button
          v-for="btn in getSelectedClub.buttons"
          :key="btn.text"
          v-bind:data="btn"
        />
      </div>
      <Suosittele />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MobileForm from "@/components/MobileForm";
import InfoCollapsible from "@/components/InfoCollapsible";
import Button from "@/components/Button";
import Suosittele from "@/components/Suosittele";

// Siirrä painikkeet clubs.js storeen!!!!

export default {
  name: "Thanks",
  components: {
    MobileForm,
    InfoCollapsible,
    Button,
    Suosittele
  },
  computed: mapGetters(["getSelectedClub", "userData"])
};
</script>

<style scoped>
.buttons {
  margin: 2em 0;
}
@media (min-width: 1025px) {
  .wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .wrapper > div {
    width: 48%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
